/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaPersonResponse model module.
 * @module model/AqaPersonResponse
 * @version v0
 */
export default class AqaPersonResponse {
  /**
   * Constructs a new <code>AqaPersonResponse</code>.
   * @alias module:model/AqaPersonResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaPersonResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaPersonResponse} obj Optional instance to populate.
   * @return {module:model/AqaPersonResponse} The populated <code>AqaPersonResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaPersonResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('accountId'))
        obj.accountId = ApiClient.convertToType(data['accountId'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('firstname'))
        obj.firstname = ApiClient.convertToType(data['firstname'], 'String');
      if (data.hasOwnProperty('lastname'))
        obj.lastname = ApiClient.convertToType(data['lastname'], 'String');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaPersonResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaPersonResponse.prototype.message = undefined;

/**
 * @member {String} id
 */
AqaPersonResponse.prototype.id = undefined;

/**
 * @member {String} accountId
 */
AqaPersonResponse.prototype.accountId = undefined;

/**
 * @member {String} email
 */
AqaPersonResponse.prototype.email = undefined;

/**
 * @member {String} firstname
 */
AqaPersonResponse.prototype.firstname = undefined;

/**
 * @member {String} lastname
 */
AqaPersonResponse.prototype.lastname = undefined;

/**
 * @member {Boolean} successful
 */
AqaPersonResponse.prototype.successful = undefined;

